import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/font-test")({
  head: () => ({
    meta: [
      { title: "Font Test — thatKorner" },
      { name: "description", content: "Internal cursive font comparison for the homepage headline." },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Allura&family=Pinyon+Script&family=Dancing+Script:wght@500;700&family=Great+Vibes&family=Tangerine:wght@400;700&family=Parisienne&family=Sacramento&family=Yellowtail&family=Petit+Formal+Script&family=Alex+Brush&family=Italianno&family=Sail&family=Pacifico&display=swap",
      },
    ],
  }),
  component: FontTestPage,
});

const FONTS: { name: string; family: string; weight?: number }[] = [
  { name: "Allura (current)", family: "'Allura', cursive" },
  { name: "Pinyon Script", family: "'Pinyon Script', cursive" },
  { name: "Dancing Script 500", family: "'Dancing Script', cursive", weight: 500 },
  { name: "Dancing Script 700", family: "'Dancing Script', cursive", weight: 700 },
  { name: "Great Vibes", family: "'Great Vibes', cursive" },
  { name: "Tangerine 400", family: "'Tangerine', cursive", weight: 400 },
  { name: "Tangerine 700", family: "'Tangerine', cursive", weight: 700 },
  { name: "Parisienne", family: "'Parisienne', cursive" },
  { name: "Sacramento", family: "'Sacramento', cursive" },
  { name: "Yellowtail", family: "'Yellowtail', cursive" },
  { name: "Petit Formal Script", family: "'Petit Formal Script', cursive" },
  { name: "Alex Brush", family: "'Alex Brush', cursive" },
  { name: "Italianno", family: "'Italianno', cursive" },
  { name: "Sail", family: "'Sail', cursive" },
  { name: "Pacifico", family: "'Pacifico', cursive" },
];

function FontTestPage() {
  return (
    <main className="min-h-screen bg-ink text-bone pt-32 pb-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <header className="mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">
            Internal · Typography lab
          </p>
          <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">
            Cursive comparison for &ldquo;Beyond&rdquo;
          </h1>
          <p className="mt-4 text-muted-foreground max-w-2xl">
            Each row pairs a handwritten script with the same Sora display sans used on the
            homepage so you can judge weight, slant, and rhythm against the PDF reference.
          </p>
        </header>

        <div className="space-y-10">
          {FONTS.map((f) => (
            <section
              key={f.name}
              className="border-t border-white/10 pt-8 grid grid-cols-1 md:grid-cols-[180px_1fr] gap-6 items-baseline"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
                  {f.name}
                </p>
              </div>
              <div className="flex items-baseline gap-4 flex-wrap">
                <span
                  className="text-ember leading-[0.9]"
                  style={{
                    fontFamily: f.family,
                    fontWeight: f.weight ?? 400,
                    fontSize: "clamp(72px, 11vw, 160px)",
                  }}
                >
                  Beyond
                </span>
                <span
                  className="font-display font-bold"
                  style={{
                    fontSize: "clamp(36px, 5vw, 72px)",
                    letterSpacing: "-0.03em",
                  }}
                >
                  the QR Code
                </span>
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
